'use strict';

var React = require('react'),
    _ = require('lodash');

var Popover = React.createClass({
	displayName: 'Popover',


	propTypes: {
		icon: React.PropTypes.string,
		opneIcon: React.PropTypes.string,
		title: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
		titleElement: React.PropTypes.element,
		style: React.PropTypes.string,
		position: React.PropTypes.string,
		width: React.PropTypes.number,
		height: React.PropTypes.number,
		onOpen: React.PropTypes.func,
		onClose: React.PropTypes.func,
		isEnabled: React.PropTypes.bool,
		isAllowClickingOutside: React.PropTypes.bool,
		className: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
		offset: React.PropTypes.object,
		closeOnPropChange: React.PropTypes.bool
	},

	getDefaultProps: function getDefaultProps() {
		return {
			onOpen: _.noop,
			onClose: _.noop,
			position: 'below',
			isEnabled: true,
			isOpen: false,
			isAllowClickingOutside: false,
			offset: {},
			closeOnPropChange: true
		};
	},

	getInitialState: function getInitialState() {
		return {
			isOpen: this.props.isOpen
		};
	},

	componentWillReceiveProps: function componentWillReceiveProps(props) {
		if (props.isOpen != this.state.isOpen) {
			if (!this.state.isOpen || this.state.isOpen && this.props.closeOnPropChange) {
				this.toggle(props.isOpen);
			}
		}
	},

	toggle: function toggle(isOpen) {
		if (!this.props.isEnabled) {
			return;
		}

		var _isOpen = typeof isOpen === 'boolean' ? isOpen : !this.state.isOpen;

		this.setState({
			isOpen: _isOpen
		});

		if (_isOpen) {
			this.props.onOpen();
			document.addEventListener('click', this.clickOutside);
		} else {
			this.props.onClose();
			document.removeEventListener('click', this.clickOutside);
		}
	},

	clickInside: function clickInside(e) {
		e.stopPropagation();
		e.preventDefault();
		return;
	},

	clickOutside: function clickOutside(e) {
		if (!this.props.isEnabled || !this.state.isOpen || e.defaultPrevented || this.props.isAllowClickingOutside) {
			return;
		}

		var target = e.target.getAttribute('class');
		if (target && _.startsWith(target, 'po-window')) {
			return;
		}

		this.toggle(false);
		document.removeEventListener('click', this.clickOutside);
	},

	componentWillUnmount: function componentWillUnmount() {
		document.removeEventListener('click', this.clickOutside);
	},


	// Helpers

	offsetLeft: function offsetLeft() {
		return this.props.offset && this.props.offset.left ? this.props.offset.left : 0;
	},

	arrowOffset: function arrowOffset() {
		var arrow = this.refs.popover.querySelector(".popover .i-v-ico");
		return arrow && arrow.offsetLeft ? arrow.offsetLeft + 4 - this.offsetLeft() : 0;
	},

	// Render

	render: function render() {

		var className = _.concat(['popover'], this.props.className),
		    windowClassName = _.concat(['po-window'], 'position-' + _.toLower(this.props.position)),
		    icon = this.state.isOpen && this.props.openIcon ? this.props.openIcon : this.props.icon,
		    container = null,
		    element = null;

		if (!this.props.isEnabled) {
			className.push('disabled');
		}

		if (this.props.style) {
			className.push('style-' + _.toLower(this.props.style));
		}

		switch (_.toLower(this.props.style)) {
			case 'icon':
				var RectIcon = require('../Icon/RectIcon');
				element = React.createElement(RectIcon, { imgSrc: icon, onClick: this.toggle });
				break;

			case 'icon-right-invert':
				if (!container && this.state.isOpen) {
					var arrow = this.refs.popover.querySelector(".popover .i-v-ico");

					var containerStyle = _.extend({ width: this.props.width, height: this.props.height }, this.props.offset);

					container = React.createElement(
						'div',
						{ className: windowClassName.join(' '), style: containerStyle },
						React.createElement(
							'div',
							{ className: 'stage', onClick: this.clickInside },
							this.props.children
						),
						React.createElement('div', { className: 'arrow', style: { left: this.arrowOffset() } })
					);

					var self = this;
					setTimeout(function () {
						if (arrow.offsetLeft != self.arrowOffset()) {
							self.forceUpdate();
						}
					}, 10);
				}

			case 'icon-right':
				var IconValueRight = require('../Icon/IconValue/IconValueRight');
				element = React.createElement(
					IconValueRight,
					{ icon: icon, onClick: this.toggle },
					this.props.title
				);
				break;

			case 'icon-left':
				var IconValueLeft = require('../Icon/IconValue/IconValueLeft');
				element = React.createElement(
					IconValueLeft,
					{ icon: icon, onClick: this.toggle },
					this.props.title
				);
				break;

			case 'button':
				var Button = require('../Forms/Button');
				element = React.createElement(Button, { label: this.props.title, onClick: this.toggle });
				break;

			default:
				element = React.createElement(
					'span',
					{ onClick: this.toggle },
					this.props.title
				);
		}

		if (!container && this.state.isOpen) {
			container = React.createElement(
				'div',
				{ className: windowClassName.join(' '), style: { width: this.props.width, height: this.props.height } },
				React.createElement(
					'div',
					{ className: 'stage', onClick: this.clickInside },
					this.props.children
				),
				React.createElement('div', { className: 'arrow' })
			);
		}

		return React.createElement(
			'div',
			{ className: className.join(' '), ref: 'popover' },
			element,
			container
		);
	}

});

module.exports = Popover;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Popover/Popover.js
// module id = 134
// module chunks = 0 1 2 3 5 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26